import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { typeSupport } from "../../../Editor/utils";
import classes from "./ImageUploadPopup.module.css";

const ImageUploadPopup = ({ close, addCallback, initValues = {} }) => {

    const { texts } = useSelector(state => state.translate);

    const [values, setValues] = useState({
        backgroundPositionX: "center",
        backgroundPositionY: "center",
        backgroundSize: "contain",
        ...initValues
    });

    const handleChangeInput = (e) => {
        setValues(prev => {
            const newValues = { ...prev };
            newValues[e.target.name] = e.target.value
            return newValues
        });
    }

    const uplaodImage = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            if (typeSupport(file.type)) {
                const url = URL.createObjectURL(file)
                setValues(prev => ({ ...prev, url: url }));
            }
            else {
                alert(texts.fileNotSupported)
            }
        });
        input.click();
    }

    return <div className={classes.Backdrop}>
        <div className={classes.ImageUploadPopup}>
            <div className={classes.Header}>
                <div className={classes.Title}>{texts.bgImage}</div>
                <div className={classes.Close} onClick={close}>x</div>
            </div>
            <div className={classes.InputUrlWrap}>
                <div className={classes.InputWrap}>
                    <div className={classes.InputText}>{texts.urlAdress}</div>
                    <input className={classes.Input} type='text' name={'url'} value={values.url} onChange={handleChangeInput}></input>
                </div>
                <div className={classes.ImageUpload} onClick={uplaodImage}></div>
            </div>
            <div className={classes.InputWrap}>
                <div className={classes.InputText}>background size</div>
                <select className={classes.Input} name="backgroundSize" onChange={handleChangeInput} value={values.backgroundSize}>
                    <option value={'cover'}>cover</option>
                    <option value={'contain'}>contain</option>
                    <option value={'auto'}>auto</option>
                    <option value={'100% 100%'}>stretch</option>
                </select>
            </div>
            <div className={classes.InputWrap}>
                <div className={classes.InputText}>background position</div>
                <div className={classes.GridWrap}>
                    <div className={classes.InputWrap}>
                        <div className={classes.InputText}>x</div>
                        <select className={classes.Input} name="backgroundPositionX" onChange={handleChangeInput} value={values.backgroundPositionX}>
                            <option value={'center'}>center</option>
                            <option value={'left'}>left</option>
                            <option value={'right'}>right</option>
                        </select>
                    </div>
                    <div className={classes.InputWrap}>
                        <div className={classes.InputText}>y</div>
                        <select className={classes.Input} name="backgroundPositionY" onChange={handleChangeInput} value={values.backgroundPositionY}>
                            <option value={'center'}>center</option>
                            <option value={'top'}>top</option>
                            <option value={'bottom'}>bottom</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className={classes.Submit} onClick={() => addCallback(values)}>{texts.ok}</div>
        </div>
    </div>
}

export default ImageUploadPopup;